module.exports = __webpack_public_path__ + "img/logo_grub-club.b8105311.svg";